import AddIcon from '@mui/icons-material/Add';
import ArrowLeft from '@mui/icons-material/ChevronLeft';
import { Button, Divider, Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'

import DeleteButton from '../components/DeleteButton'
import DeleteIconButton from '../components/DeleteIconButton'
import { ContextStore } from '../store/contextStore'
import { useIsWidthUp } from '../utils'

/**
 * Page header: title on the left, the add/delete button on the right.
 *
 * `actionsRef` (CP-8291) is a callback ref for a slot to the right of that
 * button. Page-level actions whose state lives further down the tree — the
 * Users grid's Export, which needs the tab's selection and effective filters —
 * portal themselves into it, so Export sits beside [+] here the way it does on
 * Rulesets instead of down in the search row.
 *
 * `buttonTooltip` labels the add/delete button when it renders icon-only
 * (no `buttonText`, e.g. on a phone).
 */
const UserNavigateToolbar = ({ title, addAction, buttonText, buttonTooltip, permission, goBackButtonAction, isDeleteButton, actionsRef }) => {
    const isSmallScreen = !useIsWidthUp('sm');
    const { hasPerm } = React.useContext(ContextStore);
    const btSize = isSmallScreen ? 'medium' : 'small';
    const iconOnlyTooltip = buttonText ? '' : (buttonTooltip || (isDeleteButton ? 'Delete' : 'Add'));


    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap" p={1} pt={0} pb={isSmallScreen ? 0 : 2} >
                {/* `xs` (grow) + minWidth 0 lets the title give way to the
                    buttons on a phone instead of wrapping them under it. */}
                <Grid item xs sm={'auto'} container alignItems="center" wrap="nowrap" sx={{ minWidth: 0 }}>
                    {goBackButtonAction && <Grid item xs={1} sm={'auto'} container alignItems="center" >
                        <Tooltip title="Back">
                            <ArrowLeft style={{ color: '#007AFF', cursor: 'pointer', paddingTop: '0.15rem', paddingRight: '0.25rem' }} onClick={goBackButtonAction} />
                        </Tooltip>
                    </Grid>}
                    <Grid item xs={11} sm={'auto'} pr={1} container alignItems="center" >
                        <Tooltip title={title}>
                            <Typography fontSize={20} fontWeight={700} style={{ maxWidth: 800, whiteSpace: 'nowrap', overflow: 'auto' }} >
                                {title}
                            </Typography>
                        </Tooltip>

                    </Grid>
                </Grid>
                <Grid item xs={'auto'} container alignItems="center" wrap="nowrap">
                    {addAction && !isDeleteButton && (
                        <Tooltip title={iconOnlyTooltip}>
                            <span style={{ display: 'flex' }}>
                                <Button disabled={!hasPerm(permission ? permission : 'user', 'write')} color="primary" variant="contained" size={btSize} onClick={addAction} >
                                    <AddIcon />
                                    &nbsp; {buttonText}
                                </Button>
                            </span>
                        </Tooltip>
                    )}
                    {/* CP-5545: outlined red with the label, the red trash icon alone on a phone. */}
                    {addAction && isDeleteButton && (buttonText ? (
                        <DeleteButton perm={`${permission || 'user'}.delete`} size={btSize} onClick={addAction}>
                            {buttonText}
                        </DeleteButton>
                    ) : (
                        <DeleteIconButton title={iconOnlyTooltip} perm={`${permission || 'user'}.delete`} size="medium" fontSize="medium" onClick={addAction} />
                    ))}
                    {/* Only spaced when something has been portaled in, so an
                        empty slot doesn't shift the add button. */}
                    {actionsRef && (
                        <Grid item ref={actionsRef} sx={{ display: 'flex', alignItems: 'center', '&:not(:empty)': { ml: 1 } }} />
                    )}
                </Grid>
            </Grid>
            {isSmallScreen && <Grid item xs={12} pt={1}>
                <Divider pt={1} />
            </Grid>}
        </>
    )
}

export default UserNavigateToolbar
